<template>
  <app-tooltip v-if="committeeName" text="Find this committee's secretaries (to log in as)">
    <router-link
      :to="{ name: 'Secretary Users', query: { search: committeeName } }"
      class="committee-secretaries-link"
      aria-label="Find committee secretaries"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
      </svg>
    </router-link>
  </app-tooltip>
</template>

<script>
import AppTooltip from '@/components/AppTooltip'

// Admin shortcut: jumps to Secretary Users pre-searched by this committee's name, so an admin can
// quickly find one of its secretaries and log in as them. Used by the Drafts and Committee lists.
export default {
  name: 'CommitteeSecretariesLink',
  components: { AppTooltip },
  props: {
    committeeName: { type: String, default: '' }
  }
}
</script>

<style scoped>
.committee-secretaries-link {
  display: inline-flex;
  flex: none;
  line-height: 0;
  color: var(--gray-600, #6c757d);
}

.committee-secretaries-link:hover {
  color: var(--primary, #aa2d41);
}
</style>



// WEBPACK FOOTER //
// src/components/Committees/CommitteeSecretariesLink.vue